export default __webpack_public_path__ + "static/media/explorandes4.26a4b7af.jpg";